import React, { useState } from 'react';
import { useUser } from '../contexts/UserContext';
import { UserIcon, ChevronDown } from 'lucide-react';
const users = [{
  id: 'drew',
  name: 'Drew'
}, {
  id: 'jack',
  name: 'Jack'
}, {
  id: 'justin',
  name: 'Justin'
}, {
  id: 'luke',
  name: 'Luke'
}, {
  id: 'nick',
  name: 'Nick'
}, {
  id: 'zach',
  name: 'Zach'
}];
export function LoginPage() {
  const [selectedUser, setSelectedUser] = useState<string>('');
  const {
    login
  } = useUser();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedUser) {
      login(selectedUser);
    }
  };
  const selectedUserName = users.find(u => u.id === selectedUser)?.name || '';
  return <div className="min-h-screen bg-gray-200 flex items-center justify-center p-0 sm:p-8 font-sans" data-id="element-606">
      {/* Phone Frame Container */}
      <div className="w-full max-w-[400px] bg-[#eef0f5] sm:rounded-[40px] shadow-2xl overflow-hidden min-h-[100vh] sm:min-h-[850px] relative flex flex-col" data-id="element-607">
        {/* Background Gradient Spot (Subtle) */}
        <div className="absolute top-0 left-0 w-full h-96 bg-gradient-to-b from-white/40 to-transparent pointer-events-none" data-id="element-608" />

        {/* Header with Logo */}
        <header className="w-full px-6 py-6 flex justify-center items-center z-20 relative" data-id="element-609">
          <div className="w-16 h-16 flex items-center justify-center" data-id="element-610">
            <img src="https://get.clientczar.com/wp-content/uploads/2025/12/ClientCzar-medallion-2-black-1080x1080-1.png" alt="ClientCzar Logo" className="h-16 w-16 object-contain" data-id="element-611" />
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-grow flex flex-col items-center justify-center px-6 relative z-10" data-id="element-612">
          <div className="w-full max-w-sm" data-id="element-613">
            <h1 className="text-3xl font-black text-gray-900 mb-2 text-center" data-id="element-614">
              {selectedUser ? `Welcome Back, ${selectedUserName}!` : 'Welcome Back'}
            </h1>
            <p className="text-gray-500 text-center mb-8" data-id="element-615">
              Select your profile to continue training
            </p>

            <form onSubmit={handleLogin} className="space-y-6" data-id="element-616">
              {/* User Dropdown */}
              <div data-id="element-617">
                <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-618">
                  Select User
                </label>
                <div className="relative" data-id="element-619">
                  <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none" data-id="element-620">
                    <UserIcon className="w-5 h-5 text-gray-400" data-id="element-621" />
                  </div>
                  <select value={selectedUser} onChange={e => setSelectedUser(e.target.value)} className="w-full appearance-none bg-white border-2 border-gray-200 text-gray-900 rounded-2xl focus:ring-2 focus:ring-black focus:border-black block pl-12 pr-10 py-4 font-medium transition-all" required data-id="element-622">
                    <option value="" data-id="element-623">Choose your profile...</option>
                    {users.map(user => <option key={user.id} value={user.id} data-id="element-624">
                        {user.name}
                      </option>)}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-400" data-id="element-625">
                    <ChevronDown className="w-5 h-5" data-id="element-626" />
                  </div>
                </div>
              </div>

              {/* Login Button */}
              <button type="submit" disabled={!selectedUser} className={`
                  w-full py-4 rounded-2xl font-bold text-lg transition-all duration-200 shadow-lg
                  ${selectedUser ? 'bg-black text-white hover:bg-gray-800 shadow-black/20 hover:shadow-xl active:scale-[0.99]' : 'bg-gray-200 text-gray-400 cursor-not-allowed shadow-none'}
                `} data-id="element-627">
                {selectedUser ? `Continue as ${selectedUserName}` : 'Select a user to continue'}
              </button>
            </form>

            <p className="text-center text-gray-400 text-xs mt-6" data-id="element-628">
              Your progress and stats are saved automatically
            </p>
          </div>
        </main>
      </div>
    </div>;
}